import React from "react";

const handleRenew = (event) => {
  event.preventDefault();

  if (window.Cookiebot?.renew) {
    window.Cookiebot.renew();
  }
};

const CookiePlaceholder = () => {
  return (
    <div
      className="cta theme-default cookieconsent-message"
      style={{ padding: "2rem" }}
    >
      <p>
        Omdat je de activatie van marketing cookies hebt geweigerd, kan je deze
        media-inhoud niet zien. Als je toch toegang wil tot de media-inhoud hoef
        je alleen deze cookies terug aan te zetten in{" "}
        <a href="#" onClick={handleRenew} className="cookie-link">
          je cookie voorkeursinstellingen
        </a>
        .
      </p>
    </div>
  );
};

export default CookiePlaceholder;
